/**
 * Automy.Core.Enums.Reporting.Queries.ReportingQueryDateBucket
 * Optional on aggregate date/datetime dimensions. week is ISO-8601 Monday-start UTC.
 */
export default Object.freeze({
  Day: 'day',
  Week: 'week',
  Month: 'month',
  Quarter: 'quarter',
  Year: 'year',
});
